import { type InjectionKey, type Ref } from 'vue'

export type UiFormInstance = {
  validate: () => boolean
  reset: () => void
  valid: Ref<boolean>
}

export type UiFormChild = {
  id: string
  validate: () => boolean
  reset?: () => void
  resetValidation: () => void
  /** Report the field's current validity to the form without displaying
   * errors (non-lazy forms count untouched invalid fields as invalid). */
  seedValidity?: () => void
}

export type UiFormContext = {
  register: (child: UiFormChild) => void
  unregister: (id: string) => void
  lazyValidation: boolean
  /**
   * Called by a child field after it runs its rules (input/blur/validate()).
   * Lets the form recompute overall validity live so `v-model="valid"`
   * consumers (e.g. disabled submit buttons) track field state as the user
   * types — parity with Vuetify's v-form @input behavior.
   */
  /** `silent`: validity seeded without displaying an error (untouched field). */
  onValidated?: (id: string, isValid: boolean, silent?: boolean) => void
}

export const UiFormContextKey: InjectionKey<UiFormContext> =
  Symbol('ui-form-context')
